import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-comment-sm",
  "use": "icon-comment-sm-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-comment-sm\"><g fill=\"currentColor\"><path d=\"M3 6.75v-1.5h6v1.5zM3 4.5V3h6v1.5z\" /><path d=\"M11.25 0c.21 0 .389.072.533.217A.725.725 0 0112 .75V9c0 .21-.072.389-.217.533a.725.725 0 01-.533.217H5.625L2.25 12V9.75H.75a.725.725 0 01-.533-.217A.725.725 0 010 9V.75C0 .54.072.361.217.217A.725.725 0 01.75 0h10.5zm-.75 8.25V1.5h-9v6.75h2.25v1.125L5.625 8.25H10.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol